import { ProductApiUrl } from '../config';
import axios from 'axios';

import {
    ADD_DETAIL_PRODUCT,
    CHANGE_NAV_OIL,
    DECREMENT_RANKING_OIL,
    ERROR_MESSAGE_DIALOG,
    INCREMENT_RANKING_OIL,
    RECEIVE_OIL_LIST,
    REQUEST_OIL_LIST,
    UPDATE_STATE_ORDER,
   // TOGGLE_OFERTA,
   // TOGGLE_SHOWX
} from '../constants/actionTypes';

const initialState = {
    codSubCategoria: 'S',
    isLoading: false,
    ranking: 0,
    oils: []
};

export const actionCreators = {
    decrementRanking: () => ({ type: DECREMENT_RANKING_OIL }),
    incrementRanking: () => ({ type: INCREMENT_RANKING_OIL }),
    changeNav: (_e, value) => (dispatch) => {
        dispatch({ type: CHANGE_NAV_OIL, value });
        dispatch(actionCreators.requestOils());
    },
    requestOils: () => async (dispatch, getState) => {
        if(getState().oil.isLoading) {
            return;
        }
        dispatch({ type: REQUEST_OIL_LIST });

       // var r = getState().workorder.parametro === undefined ? '' : getState().workorder.parametro ;
       var r = getState().workorder.parametro ;
       if (r === ''){
          // dispatch({ type: TOGGLE_SHOWX});
        }
        let codSubCategoria = getState().oil.codSubCategoria;
        let ranking = getState().oil.ranking + 1;
        let url = `${ProductApiUrl}/api/v1/producto/operador?categoriaId=1&codigoSubCategoria=${codSubCategoria}&combustible=G&ranking=${ranking}&tipo=${r}`;
        var response = await axios.get(url);
        var oils = response.data;


        dispatch({ type: RECEIVE_OIL_LIST, oils });
      
    },

    addQuarterProduct: () => async (dispatch, getState) => {
        let details = [...getState().order.details];
        let detail = details.filter(function(item){
            return item.codigoCategoria === 'C001'
        });
        if(detail.length === 0){
            dispatch({ type: ERROR_MESSAGE_DIALOG, message: 'Agregue un producto del tipo lubricante.' });
            return;
        }

        let productoId = detail[0].productoId;
        let url = `${ProductApiUrl}/api/v1/producto/productocuarto?productoid=${productoId}`;

        var response = await axios.get(url);
        var cuarto = response.data;

        if(cuarto.stock <= 0) {
            dispatch({ type: ERROR_MESSAGE_DIALOG, message: 'El producto no cuenta con stock disponible.' });
            return;
        }

        detail = {
            productoId: cuarto.productoId,
            dProducto: cuarto.dProducto,
            codigoCategoria: '',
            cantidad: 1,
            precioVenta: cuarto.precio,
            puntos: cuarto.puntos,
            stock: cuarto.stock - 1
        };

        dispatch(actionCreators.addDetailProduct(detail));

    },

    addDetailProduct: (detail) => (dispatch, getState) => {
        let details = [...getState().order.details];

        let index = details.findIndex(function(item){
            return item.codigoCategoria === detail.codigoCategoria;
        });

        if(index >= 0 && detail.codigoCategoria !== '') {
            dispatch({ type: ERROR_MESSAGE_DIALOG, message: 'Solo puede agregar un producto del tipo lubricante.' });
            return;
        }

        index = details.findIndex(function(item){
            return item.productoId === detail.productoId; //&& item.codigoCategoria === detail.codigoCategoria;
        });

        if(index >= 0) {
            if(details[index].stock - detail.cantidad < 0) {
                dispatch({ type: ERROR_MESSAGE_DIALOG, message: 'El código ingresado no cuenta con stock disponible.' });
                return;
            }

            details[index].cantidad += detail.cantidad;
            details[index].stock -= detail.cantidad;
        }
        else {
            details.push(detail);
        }

        dispatch({ type: ADD_DETAIL_PRODUCT, details });
        dispatch({ type: UPDATE_STATE_ORDER });
    }
    
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch(action.type) {
        case CHANGE_NAV_OIL:
            return {
                ...state,
                codSubCategoria: action.value,
                ranking: 0
            };
        case DECREMENT_RANKING_OIL:
            return {
                ...state,
                ranking: state.ranking - 1
            };
        case INCREMENT_RANKING_OIL:
            return {
                ...state,
                ranking: state.ranking + 1
            };
        case RECEIVE_OIL_LIST:
            return {
                ...state,
                isLoading: false,
                oils: action.oils
            };
        case REQUEST_OIL_LIST:
            return {
                ...state,
                isLoading: true
            };
        default:
            return state;
    }

};